import { TextField, Typography, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core'
import React, { useState } from 'react'
import LoadingButton from '../LoadingButton'

export default function SubmitModal({purchaseOrder, onSubmit}) {

  const [Comment, setComment] = useState("")
  const [Error, setError] = useState(false)
  const [isSaving, setIsSaving] = useState(false);

  const isProvisional = purchaseOrder ? purchaseOrder.isProvisional : false;
  const [IsProvisional, setIsProvisional] = useState(isProvisional || false)

  const updateComment = event => {
    const { value } = event.target;
    setError(false);
    setComment(value);
  }

  const submit = () => {
    if (!Comment || Comment.length < 1) {
      return setError(true);
    }
    setIsSaving(true);
    onSubmit(Comment, IsProvisional).catch(() => {
      setIsSaving(false);
    });

  }

  return (
    <div style={{width: '400px'}}>
      <Typography variant='h6'>Submit purchase order</Typography>
      <div style={{margin: '24px 0 0px'}}>
        <TextField
          multiline
          label='Comment'
          placeholder='Write PO request notes here'
          variant='outlined'
          InputLabelProps={{ shrink: true }}
          onChange={updateComment}
          rows={6}
          error={Error}
          fullWidth
          value={Comment}
        />
      </div>
      <div style={{margin: '12px 0 32px'}}>
        <FormControlLabel
          control={
          <Checkbox variant='outlined'
            onChange={() => setIsProvisional(!IsProvisional)}
            checked={IsProvisional}
            color="primary" />
          }
          label="Figures are provisional/TBC"
        />
        <FormHelperText style={{margin: '-3px 0 0'}}>(Please ONLY tick this if absolutely required. Requests for provisional POs are more likely to be rejected.)</FormHelperText>
      </div>
      <LoadingButton
        color="primary"
        variant="contained"
        fullWidth
        loading={isSaving}
        onClick={submit}
      >Submit</LoadingButton>
    </div>
  )
}






    